import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../images/invet_img.png';
var _hoisted_1 = {
  class: "invet_box"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "invet_content_box container"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "adv_right col-lg-4 col-md-12 col-sm-12"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "invest_img"
})], -1);

var _hoisted_5 = {
  class: "adv_left col-lg-8 col-md-12 col-sm-12"
};

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "invet_left_title"
}, "关于贝恩投资", -1);

var _hoisted_7 = {
  class: "more_invest"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 贝恩投资是全球领先的另类投资公司， 管理着约1850亿美元的资产，为投资者、团队、企业和社区创造持久的价值。贝恩投资成立于1984年，开创了以咨询为基础的私募股权投资策略，与被投公司的管理团队通力合作，用新的洞识挑战传统思想，建立伟大企业和改善公司运营。并逐步在其他资产类别中有机地扩展了这种方法，以构建世界上最强大的另类资产平台之一。贝恩投资在生命科学领域拥有广泛的知识和网络。 ");

var _hoisted_9 = {
  class: "more_bain"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 发现更多关于贝恩投资： ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_collapse, {
    accordion: true,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_collapse_item, {
        class: "article_collapse",
        name: 1
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("div", {
            class: _normalizeClass(['invet_left_intro', !$setup.showMore ? 'inv_title_text_show' : 'inv_title_none'])
          }, " 贝恩投资是全球领先的另类投资公司， 管理着约1850亿美元的资产，为投资者、团队、企业和社区创造持久的价值…… ", 2)];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("a", {
            class: "link_bain",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $setup.jumpWeb('https://www.baincapital.com/about-us');
            })
          }, "https://www.baincapital.com/")])]), _createElementVNode("div", {
            class: "invet_more inv_close",
            onClick: _cache[1] || (_cache[1] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          })];
        }),
        _: 1
      }), !$setup.showMore ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "invet_more",
        onClick: _cache[2] || (_cache[2] = function () {
          return $setup.toggleMore && $setup.toggleMore.apply($setup, arguments);
        })
      })) : _createCommentVNode("", true)])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}